module.exports = __webpack_public_path__ + "static/img/movie_h.e8f395c9.png";